import { Theme } from './@types';

export const THEME: Theme = {
  size: {
    boxSize: 24,
    padding: 4,
    borderRadius: 8,
    fontSize: 'm',
    fontColor: {
      default: 'color/content/neutral/default/normal',
      disabled: 'color/content/neutral/default/disabled',
    },
  },
};
